// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import LoadingSpinner from './view'

export default function LoadingSpinnerFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/LoadingSpinner">
      <LoadingSpinner {...props}>
        {children}
      </LoadingSpinner>
    </Flow>
  )
}
